__turbopack_context__.v({
  "centerAlign": "ProviderReviewSummary-module-scss-module__0G5T0q__centerAlign",
  "mobile": "ProviderReviewSummary-module-scss-module__0G5T0q__mobile",
  "mobileView": "ProviderReviewSummary-module-scss-module__0G5T0q__mobileView",
  "noReviews": "ProviderReviewSummary-module-scss-module__0G5T0q__noReviews",
  "noReviewsDesktop": "ProviderReviewSummary-module-scss-module__0G5T0q__noReviewsDesktop",
  "noReviewsText": "ProviderReviewSummary-module-scss-module__0G5T0q__noReviewsText",
  "noreviewsCount": "ProviderReviewSummary-module-scss-module__0G5T0q__noreviewsCount",
  "providerReviewSummary": "ProviderReviewSummary-module-scss-module__0G5T0q__providerReviewSummary",
  "ratingStarIcon": "ProviderReviewSummary-module-scss-module__0G5T0q__ratingStarIcon",
  "stickyMobileView": "ProviderReviewSummary-module-scss-module__0G5T0q__stickyMobileView",
  "stickyMobileViewAlignment": "ProviderReviewSummary-module-scss-module__0G5T0q__stickyMobileViewAlignment",
  "subText": "ProviderReviewSummary-module-scss-module__0G5T0q__subText",
});
